import {
  EnvironmentProviders,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';
import { IonicComponentRef } from '@lyceo/shared/util-models';
import { FeedbackConfig } from './feedback.models';

export const FEEDBACK_MODAL: InjectionToken<IonicComponentRef> =
  new InjectionToken<IonicComponentRef>('FEEDBACK_MODAL');

export const FEEDBACK_CONFIG: InjectionToken<FeedbackConfig> =
  new InjectionToken<FeedbackConfig>('FEEDBACK_CONFIG');

export function provideFeedback(config: FeedbackConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: FEEDBACK_CONFIG, useValue: config },
  ]);
}
